// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"46f077bb","822":"6e899b05","906":"5202e4c9","972":"7d285a07"}[chunkId] + ".chunk.css";
};